import { theme } from '@aloft/toolkit-sui';

export const svgToPng = (svg: Node | null, width: number, height: number): Promise<string> =>
  new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');

    if (ctx === null || svg === null) {
      reject(new Error('Canvas context or SVG node is null'));
    } else {
      // Set background to white
      ctx.fillStyle = theme.colors.surface1;
      ctx.fillRect(0, 0, width, height);

      const img = new Image(width, height);
      img.onload = () => {
        ctx.drawImage(img, 0, 0);
        const imageData = canvas.toDataURL('image/png', 1.0);
        resolve(imageData);
      };

      img.onerror = () => reject(new Error('Failed to load SVG image'));

      const xml = new XMLSerializer().serializeToString(svg);
      const dataUrl = `data:image/svg+xml;utf8,${encodeURIComponent(xml)}`;
      img.src = dataUrl;
    }
  });
